'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.requestGenerator = requestGenerator;

var _effects = require('redux-saga/effects');

var _compose = require('ramda/src/compose');

var _compose2 = _interopRequireDefault(_compose);

var _merge = require('ramda/src/merge');

var _merge2 = _interopRequireDefault(_merge);

var _actionHelpers = require('../actionHelpers');

var _doAction = require('./doAction');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked =
/*#__PURE__*/
_regenerator2.default.mark(requestGenerator);

function requestGenerator(actionFn, action) {
  var response, lastSucceedAt;
  return _regenerator2.default.wrap(function requestGenerator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          actionFn = (0, _compose2.default)((0, _merge2.default)({
            requestAction: action
          }), actionFn);
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.put)((0, _actionHelpers.asRequest)(actionFn(null)));

        case 4:
          return _context.delegateYield((0, _doAction.doAction)(action), 't0', 5);

        case 5:
          response = _context.t0;
          lastSucceedAt = new Date().toISOString();
          _context.next = 9;
          return (0, _effects.put)((0, _actionHelpers.asSuccess)(actionFn(response, {
            lastSucceedAt: lastSucceedAt
          })));

        case 9:
          return _context.abrupt('return', {
            response: response
          });

        case 12:
          _context.prev = 12;
          _context.t1 = _context['catch'](1);
          _context.next = 16;
          return (0, _effects.put)((0, _actionHelpers.asError)(actionFn(_context.t1)));

        case 16:
          return _context.abrupt('return', {
            error: _context.t1
          });

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 12]]);
}